import React from 'react';

import type { Props } from '../shared/types';

import { useMembershipBottomBanner } from './hooks/useMembershipBottomBanner';
import { Layout } from './layout';

export const MembershipBottomBanner: React.FC<Props> = (props) => {
	const { displayed } = useMembershipBottomBanner();
	if (!displayed) return null;

	return <Layout {...props} />;
};
